import { createContext } from "react";

export const DiscountPreviewContext = createContext<{
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  discount: DiscountPreviewVM | null;
  setDiscount: (discount: DiscountPreviewVM | null) => void;
  canShowPreview: boolean;
}>({
  isOpen: false,
  setIsOpen: () => {},
  discount: null,
  setDiscount: () => {},
  canShowPreview: false,
});
